<template>
  <div>
    <general-table
      :api-url="apiUrl"
      :block-content="false"
      :add-component-name="addComponentName"
      :add-type="addType"
      :columns="columns"
      :type="type"
      :delete-content="true"
      :edit-content="false"
      :view-content="false"
    />
  </div>
</template>

<script>
import GeneralTable from '@/components/general-table/GeneralTable.vue'

export default {
  components: { GeneralTable },
  data() {
    return {
      APIURL: 'hs-codes',
      type: 'page',
      addType: 'Add HS Code',
      addComponentName: 'add-hs-code',
      filter: {},
      types: '',
      columns: [
        // { key: 'id', label: 'Id' },
        { key: 'code', label: 'hs code' },
        { key: 'actions' },
      ],
    }
  },
  computed: {
    apiUrl() {
      let base = 'hs-codes?'

      if (!Object.values(this.filter).length) {
        return base.slice(0, -1)
      }

      // eslint-disable-next-line no-restricted-syntax
      for (const [key, value] of Object.entries(this.filter)) {
        if (key && value) {
          base += `${key}=${value}&`
        }
      }
      return base.slice(0, -1)
    },
  },
  mounted() {},

  methods: {
    filterTypes(type) {
      const filteredType = this.status.filter(item => item.text !== type)
      this.types = filteredType
    },
  },
}
</script>
